import type { ComponentType } from 'react';
import { createBrowserRouter } from 'react-router-dom';
import { wrapCreateBrowserRouterV7 } from '@sentry/react';

import Page from './pages';

const lazyRoute = (importer: () => Promise<{ default: ComponentType }>) => () =>
  importer().then((m) => ({ Component: m.default }));

const routesConfig = [
  {
    children: [
      {
        path: Page.signIn,
        lazy: lazyRoute(() => import('./routes/SignIn')),
      },
      {
        path: Page.signUp,
        lazy: lazyRoute(() => import('./routes/SignUp')),
      },
      {
        path: Page.signUpSent,
        lazy: lazyRoute(() => import('./routes/SignUpSent')),
      },
      {
        path: Page.signUpConfirm,
        lazy: lazyRoute(() => import('./routes/SignUpConfirm')),
      },
      {
        path: Page.forgotPassword,
        lazy: lazyRoute(() => import('./routes/ForgotPassword')),
      },
      {
        path: Page.forgotPasswordSent,
        lazy: lazyRoute(() => import('./routes/ForgotPasswordSent')),
      },
      {
        path: Page.newPassword,
        lazy: lazyRoute(() => import('./routes/NewPassword')),
      },
      {
        path: Page.passwordUpdated,
        lazy: lazyRoute(() => import('./routes/PasswordUpdated')),
      },
    ],
  },
  {
    path: '*',
    lazy: lazyRoute(() => import('./routes/Wildcard')),
  },
];

const sentryCreateBrowserRouter =
  wrapCreateBrowserRouterV7(createBrowserRouter);
const configuredRouter = sentryCreateBrowserRouter(routesConfig);

export default configuredRouter;
